import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
  SetFavoriteIds: "[Favorite] Set Favorite Ids",
  AddFavoriteId: "[Favorite] Add Favorite Id",
  RemoveFavoriteId: "[Favorite] Remove Favorite Id",
  ClearFavorites: "[Favorite] Clear Favorites",
};

const initialFavoriteState = {
  // Kullanıcının favorilediği ilan id'leri; kalp ikonlarının dolu/boş
  // durumunu belirler. Boot anında /v1/favorites/ids ile doldurulur.
  ids: [],
};

export const reducer = persistReducer(
  {
    storage,
    key: "v714-alicilar-favorites",
    whitelist: ["ids"],
  },
  (state = initialFavoriteState, action) => {
    switch (action.type) {
      case actionTypes.SetFavoriteIds: {
        const { ids } = action.payload;
        return { ...state, ids: ids || [] };
      }

      case actionTypes.AddFavoriteId: {
        const { id } = action.payload;
        if (state.ids.includes(id)) return state;
        return { ...state, ids: [...state.ids, id] };
      }

      case actionTypes.RemoveFavoriteId: {
        const { id } = action.payload;
        return { ...state, ids: state.ids.filter((favId) => favId !== id) };
      }

      case actionTypes.ClearFavorites: {
        return { ...state, ids: [] };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  setFavoriteIds: (ids) => ({
    type: actionTypes.SetFavoriteIds,
    payload: { ids },
  }),
  addFavoriteId: (id) => ({
    type: actionTypes.AddFavoriteId,
    payload: { id },
  }),
  removeFavoriteId: (id) => ({
    type: actionTypes.RemoveFavoriteId,
    payload: { id },
  }),
  clearFavorites: () => ({ type: actionTypes.ClearFavorites }),
};
